module.exports = __webpack_public_path__ + "static/media/image.329c9d1b.jpeg";